import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

export const TRANSFORMER = graphql.transformers.IN.enumeration<
  ents.extra.space.Report.Format,
  graphql.schema.SpaceReportFormat
>({
  [ents.extra.space.Report.Format.Html]: graphql.schema.SpaceReportFormat.Html,
  [ents.extra.space.Report.Format.Excel]:
    graphql.schema.SpaceReportFormat.Excel,
  [ents.extra.space.Report.Format.Pdf]: graphql.schema.SpaceReportFormat.Pdf,
})
